import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeaderCell,
    TableRow,
  } from '@qualtrics/ui-react';
import { getCourseLabel } from '../Util/util';
import RetakeLinksStatus from '../RetakeLinksStatus/retakeLinksStatus';
import ColoredStatus from '../ColoredStatus/coloredStatus';
import OptOutLink from '../OptOutLink/optOutLink';
import styles from './homePage.module.css';
import StudentInfo from '../StudentInfo/studentInfo';
import moment from 'moment';

const HomePage = ({
    evaluationPage,
    evaluationTasks,
    areRetakesEnabled,
    brandId,
    hashedStudentId,
    setSelectedEvaluation,
    studentId
}) => {
    const getTeachersInTaskGroup = (tasks) => {
        const teachers = [];
        tasks.filter((task) => task.teacherId !== null)
            .forEach((task) => {
                const teacherName = task.teacherName;
                if (!teachers.includes(teacherName)) {
                    teachers.push(teacherName);
                }
            });
        return teachers;
    };

    const EvaluationTableTaskRow = ({taskGroup}) => {
        const teachersInTaskGroup = getTeachersInTaskGroup(taskGroup);
        const allEvalsComplete = taskGroup.reduce((allComplete, task) => {
            return allComplete && task.completed;
        }, taskGroup[0].completed);

        return (
            <TableRow className={styles['table-row']} onClick={() => setSelectedEvaluation(taskGroup)}>
                <TableCell>
                    <ColoredStatus
                        status={allEvalsComplete ? 'Done' : 'Todo'}
                        translatedStatus={
                        allEvalsComplete
                            ? evaluationPage.evaluationComplete
                            : evaluationPage.evaluationIncomplete
                        }
                    />
                </TableCell>
                <TableCell>
                    {getCourseLabel(taskGroup[0], brandId)}
                </TableCell>
                <TableCell>
                    {teachersInTaskGroup.join(", ")}
                </TableCell>
                <TableCell>
                    {moment(new Date(taskGroup[0].expirationDate)).format('lll')}
                </TableCell>
            </TableRow>
        );
    }

    const EvaluationTable = () => {
        return (
            <div className={styles['table-wrapper']}>
                <Table className={styles['table']}>
                    <TableHead>
                        <TableRow>
                            <TableHeaderCell 
                                className={`${styles['table-header']} 
                                ${styles['status-header']}`}
                                testid={'statusColumnHeader'}
                            >
                                {evaluationPage.statusTitle}
                            </TableHeaderCell>
                            <TableHeaderCell 
                                className={`${styles['table-header']} 
                                ${styles['course-header']}`}
                                testid={'courseColumnHeader'}
                            >
                                {evaluationPage.courseTitle}
                            </TableHeaderCell>
                            <TableHeaderCell 
                                className={`${styles['table-header']} 
                                ${styles['teacher-header']}`}
                                testid={'instructorColumnHeader'}
                            >
                                {evaluationPage.teacherTitle}
                            </TableHeaderCell>
                            <TableHeaderCell 
                                className={`${styles['table-header']} 
                                ${styles['expiration-date-header']}`}
                                testid={'expirationDateColumnHeader'}
                            >
                                {evaluationPage.expirationDateTitle}
                            </TableHeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {evaluationTasks.map((taskGroup) => {
                        return <EvaluationTableTaskRow taskGroup={taskGroup} />;
                    })}
                    </TableBody>
                </Table>
            </div>
      )
    }

    return (
        <div className={styles['container']}>
            <div className={styles['top-row-wrapper']}>
                {evaluationPage.logoUrl && (
                    <div className={styles['logo']}>
                        <img src={evaluationPage.logoUrl} className={styles['logo-image']}></img>
                    </div>
                )}
                <StudentInfo hashedStudentId={hashedStudentId} brandId={brandId} />
            </div>
            <div className={styles['header']}>{evaluationPage.header}</div>
            <div className={styles['description']}>{evaluationPage.description}</div>
            <EvaluationTable />
            <div className={styles['footer']}>
                <RetakeLinksStatus retakeLinksEnabled={areRetakesEnabled} />
                <OptOutLink evaluationTasks={evaluationTasks} hashedStudentId={hashedStudentId} brandId={brandId} studentId={studentId}/>
            </div>
        </div>
      );
}

export default HomePage;